// const BASE_URL = "http://192.168.20.2:5051/lms_api/"
//demo
// const BASE_URL="https://tamer.lmsadmin.iossmlm.com/lms_api/"
//live
const BASE_URL="https://admin.icare-net.net/lms_api/"

const IMG_URL = ""

export  { BASE_URL, IMG_URL }